import { useWith, path, split } from "ramda";

import authentication from "./localization/authentication";
import users from "./localization/users";
import subscription from "./localization/subscription";
import companies from "./localization/companies";
import opportunities from "./localization/opportunities";
import organization from "./localization/organization";
import productTypes from "./localization/productTypes";
import products from "./localization/products";
import productGroups from "./localization/productGroups";
import generic from "./localization/generic";
import proposals from "./localization/proposals";
import webhooks from "./localization/webhooks";
import notifications from "./localization/notifications";
import jobs from "./localization/jobs";
import jobPhases from "./localization/jobPhases";
import customEvents from "./localization/customEvents";
import timeTracking from "./localization/timeTracking";
import fleet from "./localization/fleet";
import emailIdentity from "./localization/emailIdentity";
import projectMaps from "./localization/projectMaps";
import worksheet from "./localization/worksheet";

//    dotPath :: String -> Object -> Any
const dotPath = useWith(path, [split(".")]);

const language = "EN";

const localizations = {
  authentication,
  users,
  subscription,
  companies,
  opportunities,
  organization,
  "product-types": productTypes,
  products,
  "product-groups": productGroups,
  generic,
  proposals,
  webhooks,
  notifications,
  jobs,
  jobPhases,
  customEvents,
  "time-tracking": timeTracking,
  fleet,
  emailIdentity,
  projectMaps,
  worksheet,
};

type LocalizationStrings = typeof localizations;

type AllKeys<T> = T extends any ? keyof T : never;

type NestedKeys = {
  [Key in keyof LocalizationStrings]: `${Key}.${AllKeys<LocalizationStrings[Key]>}`;
}[keyof LocalizationStrings];

const getLocalString = (key: NestedKeys) => {
  const translation = dotPath(key)(localizations) as Record<typeof language, string> | undefined;

  if (!(typeof translation === "undefined")) {
    return translation[language];
  }

  return "Missing Localization";
};

export default getLocalString;
